import React from 'react';
import { Button, Dropdown, Form, Modal } from 'semantic-ui-react';
import { TextField } from '../../common/FormFields';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import * as selectors from '../../../redux/selectors';
import * as actions from '../../../redux/actions';
import * as yup from 'yup';
import { bindActionCreators } from 'redux';
import { upperCase } from 'lodash';
import { isEmpty } from 'ramda';

const AddSeriesModal = ({ sites, getSites, addSeries, series, types }) => {
  const [open, setOpen] = React.useState(false);

  const isReservedUrl = url => {
    if (!url) return false;
    const isMatch = s => s === upperCase(url);
    const toUrl = ({ url }) => upperCase(url);
    return !isEmpty(series.map(toUrl).filter(isMatch));
  };

  const getSlugForSeries = title => {
    const baseUrl = title
      .split(' ')
      .filter(a => a)
      .map(a => a.toLowerCase())
      .join('-');
    let offset = 1;
    let url = baseUrl;
    while (isReservedUrl(url)) {
      url = baseUrl + '-' + offset;
      offset += 1;
    }
    return url;
  };

  const validationSchema = yup.object({
    siteId: yup.string().required('A site is required'),
    internal: yup.string().required('An internal name is required'),
    external: yup.string().required('An external name is required'),
    type: yup.string().required('A type is required'),
  });

  const handleSubmit = async (data, formik) => {
    const order = series.map(s => s.data?.order).find(s => s);
    addSeries({
      ...data,
      order: order + 1,
      url: getSlugForSeries(data.internal),
      note: 'Promoted articles are produced by CultureMap sponsors and not by the editorial staff.',
    });
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Formik
      initialValues={{ siteId: '', title: '', url: '', type: '' }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {formik => (
        <Modal
          size="small"
          onClose={() => setOpen(false)}
          onOpen={() => {
            setOpen(true);
            formik.resetForm();
          }}
          open={open}
          trigger={<Button icon="plus" labelPosition="left" positive content="Add Series" />}
        >
          <Modal.Header>Add Series</Modal.Header>
          <Modal.Content>
            <Form onSubmit={formik.handleSubmit} widths="equal">
              <Form.Group>
                <Form.Field>
                  <strong>City</strong>
                  <Dropdown
                    fluid
                    search
                    selection
                    clearable
                    options={sites || []}
                    id="siteId"
                    label="Site"
                    name="siteId"
                    value={formik.values.siteId}
                    onChange={(e, { name, value }) => formik.setFieldValue(name, value)}
                    size="small"
                    error={Boolean(formik.errors.siteId)}
                  />
                </Form.Field>
              </Form.Group>
              <strong>Type</strong>
              <Form.Field>
                <Dropdown
                  fluid
                  search
                  clearable
                  selection
                  options={types.filter(t => t.value !== 'All') || []}
                  id="type"
                  label="Type"
                  name="type"
                  value={formik.values.type}
                  onChange={(e, { name, value }) => {
                    formik.setFieldValue(name, value);
                  }}
                  size="small"
                  error={Boolean(formik.errors.type)}
                />
              </Form.Field>
              <strong>Series Title</strong>
              <span style={{ fontSize: '.8rem' }}>*Creates the slug for the series</span> <br />
              <Form.Group>
                <TextField
                  name="external"
                  formik={formik}
                  value={formik.values.external}
                  onChange={formik.handleChange}
                  error={formik.errors.external}
                  errorMessage={formik.errors.external}
                />
              </Form.Group>
              <strong>Internal Series Name</strong>
              <span style={{ fontSize: '.8rem' }}></span> <br />
              <Form.Group>
                <TextField
                  name="internal"
                  formik={formik}
                  value={formik.values.internal}
                  onChange={formik.handleChange}
                  error={formik.errors.internal}
                  errorMessage={formik.errors.internal}
                />
              </Form.Group>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              content="Submit"
              disabled={!formik.isValid}
              labelPosition="left"
              icon="save"
              onClick={formik.handleSubmit}
              positive
            />
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({
  sites: selectors.admin.cultureMapSiteOptions(state),
  series: selectors.series.series(state),
  types: selectors.series.types(state),
});

const mapDispatchToProps = dispatch => ({
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
  addSeries: bindActionCreators(actions.series.addSeries, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddSeriesModal);
